import {
  MENU_TOGGLE,
  SIDER_TOGGLE,
  GET_CONFIG_PENDING,
  GET_CONFIG_SUCCES,
  GET_CONFIG_FAILURE,
} from "./mainTypes";

export const menuToggle = () => {
  return {
    type: MENU_TOGGLE,
  };
};

export const siderToggle = () => {
  return {
    type: SIDER_TOGGLE,
  };
};

export const getConfig = () => {
  return (dispatch: any) => {
    dispatch(getConfigPending());
    fetch("config.json")
      .then((response) => {
        if (!response.ok) throw response;
        return response.json();
      })
      .then((data) => {
        dispatch(getConfigSucces(data));
      })
      .catch((error) => {
        dispatch(getConfigFailure(error));
      });
  };
};

const getConfigPending = () => {
  return {
    type: GET_CONFIG_PENDING,
  };
};

const getConfigSucces = (data: any) => {
  return {
    type: GET_CONFIG_SUCCES,
    data: data,
  };
};

const getConfigFailure = (error: any) => {
  return {
    type: GET_CONFIG_FAILURE,
    error: error,
  };
};
